<template>
  <div>
    <div
      v-if="!submitted"
      class="dashboard-password"
    >
      <h3 class="h3 mt0">Reset Password</h3>
      <p class="p">Something about reseting your password</p>
      <module-form
        form-id="dashboard-password"
        :fields="resetPassword"

        button-size="m"
        button="primary"

        :action="action"
        :success="success"
        :fail="fail"
      />
    </div>
    <div
      v-else
      class="dashboard-password"
    >
      <h3 class="h3 mt0">Your password has been reset</h3>
      <p class="p">Something about reseting your password</p>
      <module-button
        level="secondary"
        label="Got It"
        button="primary"
        @click.native="showForm()"
      />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import { resetPassword } from 'models/auth/index';

// Modules
import ModuleButton from 'modules/Button';
import ModuleForm from 'modules/Form';

// Export
export default {
  name: `ui-dashboard-password`,

  components: {
    ModuleButton,
    ModuleForm,
  },

  // Data
  data() {
    return {
      resetPassword,
      submitted: false,
    };
  },
  computed: {
    ...mapGetters(`forms`, [
      `getModel`,
    ]),
    model() {
      return this.getModel(`dashboard-password`);
    },
  },

  // Methods
  methods: {
    ...mapActions(`auth`, [
      `requestUpdatePassword`,
    ]),
    action() {
      return this.requestUpdatePassword(this.model);
    },
    success(/*success*/) {
      setTimeout(() => {
        this.submitted = true;
      }, 1000);
    },
    fail(fail) {
      console.warn(fail);
    },
    showForm() {
      this.submitted = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Password.vue?5710cba0